export default "__VITE_ASSET__Bme4U927__"